module.exports = __webpack_public_path__ + "img/react.14fa5904.svg";